import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1d3b0ce4 from 'nuxt_plugin_plugin_1d3b0ce4' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_libplugin753d59ca_6831242d from 'nuxt_plugin_libplugin753d59ca_6831242d' // Source: ./lib.plugin.753d59ca.js (mode: 'client')
import nuxt_plugin_gtm_4cd66b50 from 'nuxt_plugin_gtm_4cd66b50' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_recaptcha_f7e1212e from 'nuxt_plugin_recaptcha_f7e1212e' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_plugin_a811f66a from 'nuxt_plugin_plugin_a811f66a' // Source: ./plugin.js (mode: 'all')
import nuxt_plugin_axios_5c03240c from 'nuxt_plugin_axios_5c03240c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_1d7318fe from 'nuxt_plugin_pluginutils_1d7318fe' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6f78248c from 'nuxt_plugin_pluginrouting_6f78248c' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_03cc1b3a from 'nuxt_plugin_pluginmain_03cc1b3a' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_image_85f52a16 from 'nuxt_plugin_image_85f52a16' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_b73e4cbc from 'nuxt_plugin_cookieuniversalnuxt_b73e4cbc' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_vuescrollto_e0b46a62 from 'nuxt_plugin_vuescrollto_e0b46a62' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_workbox_642966d4 from 'nuxt_plugin_workbox_642966d4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_b55cc4ae from 'nuxt_plugin_metaplugin_b55cc4ae' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_initialFpPromise_29808393 from 'nuxt_plugin_initialFpPromise_29808393' // Source: ../plugins/initialFpPromise.js (mode: 'client')
import nuxt_plugin_initialClientPlugin_6aeae70c from 'nuxt_plugin_initialClientPlugin_6aeae70c' // Source: ../plugins/initialClientPlugin.js (mode: 'client')
import nuxt_plugin_initialSourcebuster_4a29abae from 'nuxt_plugin_initialSourcebuster_4a29abae' // Source: ../plugins/initialSourcebuster.js (mode: 'client')
import nuxt_plugin_toast_bc840172 from 'nuxt_plugin_toast_bc840172' // Source: ../plugins/toast.js (mode: 'all')
import nuxt_plugin_vuemask_613243e6 from 'nuxt_plugin_vuemask_613243e6' // Source: ../plugins/vue-mask.js (mode: 'all')
import nuxt_plugin_casewords_209a4398 from 'nuxt_plugin_casewords_209a4398' // Source: ../plugins/case-words.js (mode: 'all')
import nuxt_plugin_dateformat_2629ded8 from 'nuxt_plugin_dateformat_2629ded8' // Source: ../plugins/date-format.js (mode: 'all')
import nuxt_plugin_vuejsmodal_0719e4a0 from 'nuxt_plugin_vuejsmodal_0719e4a0' // Source: ../plugins/vue-js-modal.js (mode: 'all')
import nuxt_plugin_numberformat_24c7baf3 from 'nuxt_plugin_numberformat_24c7baf3' // Source: ../plugins/number-format.js (mode: 'all')
import nuxt_plugin_yandexcommerce_db9cc512 from 'nuxt_plugin_yandexcommerce_db9cc512' // Source: ../plugins/yandex-commerce.js (mode: 'all')
import nuxt_plugin_convertCurrency_12b2deac from 'nuxt_plugin_convertCurrency_12b2deac' // Source: ../plugins/convertCurrency.js (mode: 'all')
import nuxt_plugin_hreflangInitial_6839e0c3 from 'nuxt_plugin_hreflangInitial_6839e0c3' // Source: ../plugins/hreflangInitial.js (mode: 'all')
import nuxt_plugin_defaultcountryselection_3aee2125 from 'nuxt_plugin_defaultcountryselection_3aee2125' // Source: ../plugins/default-country-selection.js (mode: 'all')
import nuxt_plugin_sitisimg_68a44871 from 'nuxt_plugin_sitisimg_68a44871' // Source: ../node_modules/sitis-nuxt/plugins/sitis-img.js (mode: 'all')
import nuxt_plugin_vuevuelidate_f5cc2938 from 'nuxt_plugin_vuevuelidate_f5cc2938' // Source: ../plugins/vue-vuelidate.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Grizzly SMS","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=1"},{"hid":"metadescription","name":"description","content":""},{"name":"yandex-verification","content":"da025be989781d0e"},{"name":"verification","content":"13a5535b595fd9f5e4892f35701d50"},{"name":"build-version","content":1745838634835},{"name":"msapplication-TileColor","content":"#da532c"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#5bbad5"},{"rel":"preload","as":"image","href":"\u002Flogos\u002Flogo-light-v1.svg"},{"rel":"stylesheet","href":"\u002Ffonts\u002Ffonts.css"},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FManrope-Regular.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FManrope-Bold.woff2","crossorigin":true},{"rel":"preload","as":"font","type":"font\u002Fwoff2","href":"\u002Ffonts\u002FManrope-Medium.woff2","crossorigin":true}],"style":[{"type":"text\u002Fcss","cssText":"\n  @font-face {\n    font-family: \"Manrope\";\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src:\n      url(\u002Ffonts\u002FManrope-Regular.woff2) format('woff2'),\n      url(\u002Ffonts\u002FManrope-Regular.woff) format('woff');\n  }\n\n  @font-face {\n    font-family: \"Manrope\";\n    font-style: normal;\n    font-weight: 500;\n    font-display: swap;\n    src:\n      url(\u002Ffonts\u002FManrope-Medium.woff2) format('woff2'),\n      url(\u002Ffonts\u002FManrope-Medium.woff) format('woff');\n  }\n\n  @font-face {\n    font-family: \"Manrope\";\n    font-style: normal;\n    font-weight: 600;\n    font-display: swap;\n    src:\n      url(\u002Ffonts\u002FManrope-SemiBold.woff2) format('woff2'),\n      url(\u002Ffonts\u002FManrope-SemiBold.woff) format('woff');\n  }\n\n  @font-face {\n    font-family: \"Manrope\";\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src:\n      url(\u002Ffonts\u002FManrope-Bold.woff2) format('woff2'),\n      url(\u002Ffonts\u002FManrope-Bold.woff) format('woff');\n  }\n"},{"type":"text\u002Fcss","cssText":".header-one {width: 100%;z-index: 30;position: sticky;top: 0;display: flex;flex-direction: column;margin-bottom: 24px;background-color: var(--tm-bg-color);}.innerSticky {width: 100%;z-index: 20;transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);transition-duration: 200ms;height: 64px;}.tm-header__wrapper {display: flex;align-items: center;justify-content: space-between;height: 100%;width: 100%;margin: 0 auto;max-width: 1400px;}.tm-header__wrapper \u003E a {display: inline-flex;margin-top: -4px;}.tm-header__wrapper \u003E a:hover {opacity: 1;}.tm-header__wrapper \u003E a:focus {outline: 2px solid transparent;outline-offset: 2px;}.header-one ul {padding-left: 0;}.nav-top__svg-block {display: flex;justify-content: center;align-items: center;width: 45px;height: 45px;cursor: pointer;}.tm-header-svg {fill: var(--tm-header-svg-fill);}html[data-theme ='dark'] .tm-heder-logo .dark-logo {display: inline-block;}html[data-theme ='dark'] .tm-heder-logo .light-logo {display: none;}.dark-logo {display: none;}.light-logo {display: inline-block;}.tm-heder-logo {overflow: hidden;display: inline-block;position: relative;width: 200px;height: 40px;}.tm-heder-logo img, .nav-top__svg-block img {width: 100%;height: 100%;}.menuItem \u003E a {color: var(--tm-nav-links-color);cursor: pointer;padding: 12px 0;display: inline-flex;align-items: center;font-size: 1rem;line-height: 1.5rem;font-weight: 600;}.menuItem \u003E div:hover, .menuItem \u003E a:hover {color: var(--primary);}.tm-header__controls {position: relative;display: flex;z-index: 10;margin-right: 24px;align-items: center;top: 1px;}.tm-header__currency {display: block;}.tm-header__search-wrapper {display: flex;}.tm-header__search-wrapper \u003E div {display: none;}.tm-header-theme {background-color: var(--tm-header-btn-bg);font-weight: 600;transition: all 0.7s;}.tm-header-theme:hover {background-color: var(--tm-select-color);}.tm-header-btn {background-color: var(--tm-header-btn-bg);font-weight: 600;transition: all 0.7s;color: var(--primary);}.tm-header-btn:hover {background-color: var(--primary);color: white;}.tm-header-btn:hover \u003E svg path {transition: all 0.7s;fill: white;}.header-one .headerMenu .menuItem \u003E a:before {bottom: -22px;}.headerMenu {display: flex;transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);transition-duration: 200ms;transition-property: all;padding-left: 30px;position: relative;width: 80%;}.headerMenu \u003E .menuItem:not(:first-child) {margin-left: 40px;}.headerMenu .menuItem \u003E a:before {content: \"\";height: 3px;transition: all 0.3s ease-in-out 0s;bottom: -14px;position: absolute;width: 0;background-color: #02b290;}.shadow-dropDown {box-shadow: 0px 10px 40px rgba(41, 50, 68, 0.15);}.subMenu {visibility: hidden;transition: all 0.4s;top: calc(100% + 21px);width: 240px;}.cart-counter-badge {min-width: 20px;min-height: 20px;padding: 2px;border-radius: 20px;font-size: 10px;}.headerShadow {box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);}@media (max-width: 1320px) {.headerMenu {padding-left: 24px;}.headerMenu \u003E div:not(:first-child) {margin-left: 16px;}.menuItem \u003E div {margin-left: 0;}}@media (max-width: 990px) {.header-one {margin-bottom: 12px;}.headerMenu {display: none;}.menuItem \u003E div, .menuItem \u003E a {font-size: 0.875rem;line-height: 1.25rem;}.tm-header__controls {top: 0;gap: 8px;margin-right: 0;}.tm-header__search-wrapper {display: flex;}.tm-header__search-wrapper \u003E div {width: 32px;display: block;}.tm-header__search-wrapper span {cursor: pointer;display: flex;justify-content: center;align-items: center;width: 32px;height: 32px;border-radius: 5px;}.tm-header__search-wrapper span:hover {opacity: 0.9;}}@media (max-width: 768px) {.tm-heder-logo {height: 36px;width: 176px;}}@media (max-width: 660px) {.tm-header__currency {display: none;}}@media (max-width: 600px) {.nav-top__svg-block {width: 35px;}}:root {--primary: #fa7900;--secondary: #f5f5f5;--black: #22252d;--white: white;--secondary-daisy: 240deg 0% 96%;--primary-daisy: 29deg 100% 49%;--tm-bg-color: var(--secondary);--tm-text-color: #22252d;--tm-nav-panel--bg: var(--primary);--tm-nav-panel-mobile--container-bg: var(--secondary);--tm-btn-bg: white;--tm-btn-nav-bg: #fc9333;--tm-btn-color: white;--tm-btn-nav-color--active: var(--primary);--tm-btn-nav-bg--active: white;--tm-header-svg-fill: black;--tm-nav-links-color: var(--black);--tm-header-btn-bg: rgba(34, 37, 45, 0.04);--tm-select-color: var(--black);--tm-footer-privace: #575a64;--tm-active-number-bg: #eaf4dd;--tm-about-gradient: linear-gradient(180deg, #ededed 14.44%, rgba(0, 0, 0, 0) 94.88%);--header-link: black;--primary-background: 0deg 0% 100%;--secondary-background: 219deg 17% 28%;--base-100: 0deg 100% 100%;--base-200: 0deg 0% 93%;--p: var(--primary-daisy);--pf: var(--primary-daisy);--pc: var(--primary-background);--s: var(--secondary-daisy);--sf: var(--secondary-daisy);--sc: var(--secondary-background);--b1: var(--base-100);--b2: var(--base-200);}[data-theme ='dark'] {--tm-input-color: black;--tm-bg-color: #241706;--tm-text-color: white;--base-100: 33deg 85% 5%;--secondary: #4c2910;--secondary-daisy: 25deg 65% 18%;--tm-nav-panel--bg: var(--secondary);--tm-btn-nav-bg: var(--primary);--tm-nav-panel-mobile--container-bg: #241706;--tm-btn-color: white;--tm-btn-nav-color--active: var(--primary);--tm-btn-nav-bg--active: white;--tm-header-svg-fill: white;--tm-header-btn-bg: var(--secondary);--tm-nav-links-color: var(--primary);--tm-select-color: var(--white);--tm-footer-privace: var(--secondary);--tm-active-number-bg: #253e05;--base-200: var(--base-100);--tm-about-gradient: linear-gradient(180deg, #180e02 14.44%, rgba(0, 0, 0, 0) 94.88%);}"}],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-W24Z4JV7')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-W24Z4JV7&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1d3b0ce4 === 'function') {
    await nuxt_plugin_plugin_1d3b0ce4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libplugin753d59ca_6831242d === 'function') {
    await nuxt_plugin_libplugin753d59ca_6831242d(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_4cd66b50 === 'function') {
    await nuxt_plugin_gtm_4cd66b50(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_f7e1212e === 'function') {
    await nuxt_plugin_recaptcha_f7e1212e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_a811f66a === 'function') {
    await nuxt_plugin_plugin_a811f66a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5c03240c === 'function') {
    await nuxt_plugin_axios_5c03240c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1d7318fe === 'function') {
    await nuxt_plugin_pluginutils_1d7318fe(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6f78248c === 'function') {
    await nuxt_plugin_pluginrouting_6f78248c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_03cc1b3a === 'function') {
    await nuxt_plugin_pluginmain_03cc1b3a(app.context, inject)
  }

  if (typeof nuxt_plugin_image_85f52a16 === 'function') {
    await nuxt_plugin_image_85f52a16(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_b73e4cbc === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_b73e4cbc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_e0b46a62 === 'function') {
    await nuxt_plugin_vuescrollto_e0b46a62(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_642966d4 === 'function') {
    await nuxt_plugin_workbox_642966d4(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_b55cc4ae === 'function') {
    await nuxt_plugin_metaplugin_b55cc4ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initialFpPromise_29808393 === 'function') {
    await nuxt_plugin_initialFpPromise_29808393(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initialClientPlugin_6aeae70c === 'function') {
    await nuxt_plugin_initialClientPlugin_6aeae70c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initialSourcebuster_4a29abae === 'function') {
    await nuxt_plugin_initialSourcebuster_4a29abae(app.context, inject)
  }

  if (typeof nuxt_plugin_toast_bc840172 === 'function') {
    await nuxt_plugin_toast_bc840172(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_613243e6 === 'function') {
    await nuxt_plugin_vuemask_613243e6(app.context, inject)
  }

  if (typeof nuxt_plugin_casewords_209a4398 === 'function') {
    await nuxt_plugin_casewords_209a4398(app.context, inject)
  }

  if (typeof nuxt_plugin_dateformat_2629ded8 === 'function') {
    await nuxt_plugin_dateformat_2629ded8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsmodal_0719e4a0 === 'function') {
    await nuxt_plugin_vuejsmodal_0719e4a0(app.context, inject)
  }

  if (typeof nuxt_plugin_numberformat_24c7baf3 === 'function') {
    await nuxt_plugin_numberformat_24c7baf3(app.context, inject)
  }

  if (typeof nuxt_plugin_yandexcommerce_db9cc512 === 'function') {
    await nuxt_plugin_yandexcommerce_db9cc512(app.context, inject)
  }

  if (typeof nuxt_plugin_convertCurrency_12b2deac === 'function') {
    await nuxt_plugin_convertCurrency_12b2deac(app.context, inject)
  }

  if (typeof nuxt_plugin_hreflangInitial_6839e0c3 === 'function') {
    await nuxt_plugin_hreflangInitial_6839e0c3(app.context, inject)
  }

  if (typeof nuxt_plugin_defaultcountryselection_3aee2125 === 'function') {
    await nuxt_plugin_defaultcountryselection_3aee2125(app.context, inject)
  }

  if (typeof nuxt_plugin_sitisimg_68a44871 === 'function') {
    await nuxt_plugin_sitisimg_68a44871(app.context, inject)
  }

  if (typeof nuxt_plugin_vuevuelidate_f5cc2938 === 'function') {
    await nuxt_plugin_vuevuelidate_f5cc2938(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
